// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { polygonZkEvmCardona as _polygonZkEvmCardona } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the polygonZkEvmCardona chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 2442
 * Chain Name: Polygon zkEVM Cardona
 * Default Block Explorer: https://cardona-zkevm.polygonscan.com
 * Default RPC URL: https://rpc.cardona.zkevm-rpc.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { polygonZkEvmCardona } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: polygonZkEvmCardona,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const polygonZkEvmCardona = createCommon({
	..._polygonZkEvmCardona,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
